<template>
    <div
        class="search-list"
        ref="typeList"
        :style="`${!isLastPage?'min-height:'+(minHeight+10)+'px;': ''}`"
    >
        <!--<div class="info-box">-->
            <!--<p class="back" @click="handleBack">-->
                <!--<span class="el-icon-arrow-left"></span>-->
                <!--<span class="name">返回</span>-->
            <!--</p>-->
            <!--<p class="sousuo">搜索到{{count || 0}}张相关素材</p>-->
        <!--</div>-->
        <div class="item-box"
             :class="{'noData': count === 0}"
        >
            <div class="blank" v-if="count === 0">
                <img :src="$images.global.blank" alt="" />
                <span class="name">搜索为空</span>
            </div>
            <div
                    class="item"
                    :class="{audio: type ==='audio'}"
                    :style="type==='template'?`width: calc(100% - 2px);`:(form.length>0?`width:${100/2-2}%;`:``)"
                    v-for="(item,index) in curForm"
                    :key="index"
            >
                <AudioBox
                        v-if="type==='audio'"
                        :item.sync="item"
                        :isSearch="true"
                        @handlePlay="handlePlay"
                        @handleStatus="handleStatus"
                />
                <VideoItem
                        v-else-if="type==='video'"
                        :index.sync="index"
                        :url.sync="item.url"
                        :item.sync="item"
                        @click.native="handleSelectItem(item)"
                        @handleSelect="handleSelect"
                        @handleOut="handleOut"
                        @onBackground="$emit('onBackground', item, 'backgroundVideo')"
                />
                <TemplateItem
                        v-else-if="type==='template'"
                        :item.sync="item"
                        @onSelect="handleSelectItem(item)"
                />
                <CompImgBox
                    v-else
                    :item="item"
                    :isBackground="isSetBackground"
                    @onBackground="handleSetBackground(item)"
                    @onSelect="handleSelectItem(item)"
                    @onMouseenter.stop="handleSelect(item, $event)"
                    @onMouseleave.stop="handleOut($event)"
                />
            </div>
            <p v-if="isLastPage && curForm.length" class="last-info">{{$enums.configInfo.moreInfo}}</p>
        </div>

        <div class="pre-box"
             :style="`right: ${position.x}px;top: ${position.y}px`"
             :class="{show: isShowPre}"
        >
            <video v-if="type==='video' && curMaterial"
                   crossOrigin="anonymous"
                   ref="video"
                   class="curImg"
                   autoplay="autoplay"
                   :src="curMaterial"
            >
            </video>
            <p v-else class="img-box">
                <span class="sp-img">
                    <img crossorigin="anonymous" class="curImg" :src="curMaterial || $images.material.default" alt="curImg" />
                </span>
            </p>
            <p class="curName">
                <span class="name">{{curName}}</span>
                <Tips
                        :type="type"
                        :data="[
                        {name: '线上', type: 'on-line', show: curItem.is_online},
                        {name: '线下', type: 'off-line', show: curItem.is_offline},
                        {name: '答题器', type: 'double', show: curItem.is_double_teacher},
                        {name: '课后', type: 'exercise', show: curItem.is_exercise},
                    ]"
                />
            </p>
            <p class="line"></p>
            <p class="remark">{{curItem.description}}</p>
        </div>
        <WarnInfo
            :isWarnInfo.sync="isWarnInfo"
            :loading.sync="isLoadingSubmit"
            :type="type"
            @success="submit"
        />
    </div>
</template>

<script>
    import Tips from '../tips'
    import AudioBox from '../selectList/components/audioBox'
    import VideoItem from '../typeList/components/video'
    import TemplateItem  from '../typeList/components/template'
    import TypeList from '../typeList'
    import WarnInfo from '../typeList/components/warnInfo'
    import {AudioPlay, AudioPause} from "../../../../../../../../utils/audio";

    export default {
        name: "search-list",
        mixins: [TypeList],
        components: {
            AudioBox,
            VideoItem,
            Tips,
            TemplateItem,
            WarnInfo
        },
        props: {
            minHeight: [Number, String],
            form: Array,
            type: String,
            isPlat: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            lastPage: [String, Number]
        },
        computed: {
          count(){
              return this.form.length
          },
          isSetBackground () {
            return this.type === 'image'
          },
          isLastPage(){
            let state = false
            try {
                state = this.curPage >= this.last_page
            } catch (e) {
                console.log('获取isLastPage1==>', e)
            }
            return state && this.count !== 0
          }
        },
        created(){
        },
        watch: {
            form(vl){this.newForm = vl},
            newForm(vl){
                this.$emit('update:form', vl)
                this.curPage = 1
                this.curForm = []
                this.appendData({page: this.curPage})
                //
                //
                // let div = document.querySelector('.item-box')
                // console.log('滚动元素==>', div)
                // div.scrollTop = 0
                // div.onscroll = (e) => {
                //     // 如果滚动已经滚到当前页的底部，就加载下一个， 判断是否到最后一页了
                //
                //     let isAudio = this.type === 'audio'
                //     let h = div.offsetHeight
                //     let realH = this.curForm.length / 2 * 90
                //     if(isAudio) realH = this.curForm.length * 72
                //     let aH = realH - h
                //
                //     console.log('滚动==>', e, div.scrollTop, h, realH, aH)
                //     if(div.scrollTop>=(aH - 20)){
                //         this.curPage = this.curPage + 1
                //         this.appendData({page: this.curPage})
                //     }
                //
                // }
            },
            loading(vl){this.isLoading = vl},
            isLoading(vl){this.$emit('update:loading', vl)},
            isShowPre(vl){
                if(vl){
                    $eventBus.$emit('onCocosDisabled', true)
                } else {
                    $eventBus.$emit('onCocosDisabled', false)
                }
            }
        },
        data () {
            return {
                isWarnInfo: false, // 确认弹窗
                isLoadingSubmit: false, // 当前是否正在确认
                fnNext: null, // 当确认点击后需要执行的事件回调

                isLoading: this.loading,
                newForm: this.form,
                curForm: [],
                curPage: 1,
                last_page: this.last_page,

                isShowPre: false, // 显示预览
                curItem: {}, // 当前素材所有字段
                curMaterial: '', // 当前展示素材
                curName: '', // 当前展示素材名称
                position: {
                    x: 400,
                    y: 250
                },
            }
        },
        methods: {
            submit(){
                const fn = setTimeout(()=>{
                    if(this.fnNext) {
                        this.fnNext()
                        this.fnNext = null
                    }
                    this.isLoadingSubmit = false
                    this.isWarnInfo = false
                    clearTimeout(fn)
                }, 100)
            },
            scrollTodo(){
                console.log('搜索下一页==>')
                // 1.如果 滚动的距离 === 文本实际渲染高度【contentHeight】 - 浏览器可视高度【boxHeight】
                // 2.加载下一页
                if(
                    !this.isLastPage &&
                    !this.isLoading &&
                    this.curPage < this.last_page
                ){
                    this.isLoading = true

                    const fn = setTimeout(()=>{
                        this.isLoading = false
                        this.curPage = this.curPage + 1
                        this.appendData({page: this.curPage})
                        clearTimeout(fn)
                    }, 500)
                }
            },
            handleMore(){
                console.log('获取下一个')
            },
            // 当前预览素材
            handleSelect (item, e) {
                const screenHeight= document.documentElement.clientHeight
                const divHeight = document.querySelector('.search-list .pre-box').clientHeight
                const minHeght = screenHeight - divHeight
                this.curItem = item
                this.curMaterial = item.url || item.cover
                this.curName = item.alias || item.name
                // console.log('鼠标移入==>', e)
                const y = e.pageY - 80
                this.position.y = (screenHeight - divHeight)<y?minHeght:y

                this.position.x = this.$refs.typeList.clientWidth + 120

                this.isShowPre = true

            },
            // 每页20条数据，翻页展示
            appendData({page}){
                if(Array.isArray(this.newForm)) {
                    const perPage = 16
                    let newData = this.newForm.slice(perPage * (page - 1), perPage * (page - 1) + perPage)
                    this.curForm = this.curForm.concat(newData)
                    this.last_page = Math.ceil(this.newForm.length / 16)
                    // debugger
                }
            },
            handleBack(){
                this.$emit('onBack')
            },
            handlePlay(item,index,index2,isOld){
                let state = false
                let index1 = -1
                this.newForm.map((v,i)=>{
                    if(`${item.id}` === `${v.id}`){
                        index1 = i
                        state = v.play
                    }
                })
                if(!state){
                    AudioPlay({url:item.url, isOld})
                }else{
                    AudioPause()
                }
                let data = this.$_.cloneDeepWith(this.newForm)
                data.map((v,i)=>{
                    if(index1 !== i){
                        v.play = false
                    }
                })
                data[index1].play = !item.play
                this.newForm = data

            },
            handleStatus(item,index,index2){
                console.log(index2)
                let index1 = -1
                this.newForm.map((v,i)=>{
                    v.status = false
                    if(`${item.id}` === `${v.id}`){
                        index1 = i
                    }
                })
                console.log('status==>1', item,index,index1)
                let data = this.$_.cloneDeepWith(this.newForm)
                data[index1].status = !item.status
                this.newForm = data

                // 向cocos通知 添加/删除
                /**
                 game: 游戏
                 resources: 资源
                 shop-resources: 公共资源（资源商城）
                 * */
                let type = 'resources'
                if(this.isPlat) type = 'shop-resources'
                if(data[index1].status) {
                    this.$toCocosMessage({
                        type: 'AddResource',
                        value: {'type': 'audio', url: item.url}
                    })
                    this.$store.dispatch('setUrlMap',{mark:'service-map-object', type, id: item.id,url: this.$utils.getAllMd5({data: item.url})[0]})
                }else{
                    this.$toCocosMessage({
                        type: 'DelResource',
                        value: {'type': 'audio', url: item.url}
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pre-box{
        position: fixed;
        top: 0px;
        right: 0px;
        background-color: white;
        width:400px;
        background:rgba(255,255,255,1);
        border-radius: 4px;
        box-shadow:0px 2px 8px 0px rgba(0,0,0,0.15);
        text-align: center;
        transition: all .2s linear;
        opacity: 0;
        visibility: hidden;

        &.show{
            visibility: initial;
            opacity: 1;
            z-index: 101;
        }

        .curImg{
            width: 360px;
            height: 223px;
            object-fit: contain;
            margin-top: 20px;
        }

        .curName {
            text-align: left;
            font-size:16px;
            font-weight:500;
            color:rgba(48,49,51,1);
            line-height:22px;
            margin: 10px 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
        }
        .line{
            width: calc(100% - 40px);
            height: 1px;
            background-color: #DDDDDD;
            margin: 20px;
        }
        .remark{
            font-size: 14px;
            text-align: left;
            font-weight: 400;
            color: #95989E;
            line-height: 20px;
            margin: 12px 20px 10px;
            position: relative;
            top: -8px;
        }
    }
    .search-list{
        display: flex;
        flex-direction: column;
        /*margin-top: 10px;*/

        .info-box{
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            font-size:14px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:20px;

            .back {
                cursor: pointer;
                &:active {
                    opacity: .5;
                }
            }
        }

        .item-box{
            /*height: calc(100vh - 232px);*/
            /*width: 106%;*/
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            margin: 10px 0px;
            /*overflow-y: auto;*/
            /*transition: all .2s linear;*/
            align-content: flex-start;
            padding-bottom: 60px;

            &.noData{
                margin-top: 50%;
            }

            .last-info{
                width: 100%;
                font-size: 14px;
                font-weight: 400;
                color: #656773;
                line-height: 60px;
                text-align: center;
            }

            .blank{
                display: flex;
                width: 100%;
                flex:1;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                padding-top: 30px;

                .name{
                    margin-top: 10px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #656773;
                    line-height: 20px;
                }
            }

            &.show{
                height: 100%;
            }

            .item{
                width: 32%;
                margin-bottom: 10px;

                &.audio {
                    width: 100% !important;
                }
                .img-box {
                    width: 100%;
                    height: 80px;
                    position: relative;
                    cursor: pointer;
                    background: #f1f1f1;
                    border-radius: 4px;

                    .txt-box {
                        position: absolute;
                        width: 100%;
                        /*height: 100%;*/
                        bottom: 0px;
                        left: 0px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;

                        .name {
                            background: rgba(0, 0, 0, 0.25);
                            font-size: 12px;
                            padding: 4px;
                            color: rgba(255, 255, 255, 0.85);
                        }
                    }
                    .set-bg{
                        position: absolute;
                        top: 6px;
                        left: 8px;
                        font-size: 12px;
                        /*border: 1px solid #eee;*/
                        background-color: rgba(255, 255, 255, 0.8);
                        border-radius: 12px;
                        padding: 2px 4px;
                        color: #303133;
                        transition: all .2s linear;

                        &:hover{
                            background-color: #e7622e;
                        }
                        &:active{
                            opacity: .8;
                            top: 6px;
                        }
                    }
                    .img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border-radius: 10px;
                    }
                    .love-box{
                        position: absolute;
                        top: 8px;
                        right: 8px;
                        cursor: pointer;

                        .img{
                            width: 20px;
                            height: 18px;
                        }
                    }
                }
            }
        }
    }
</style>
